module.exports = __webpack_public_path__ + "static/media/fitbit.b5e2b1e4.svg";